import { useEffect } from "react";
import { useLocation } from "react-router";
import AboutHero from "../components/about/AboutHero";
import AboutRail from "../components/about/AboutRail";
import AboutIdentity from "../components/about/AboutIdentity";
import AboutPlatform from "../components/about/AboutPlatform";
import AboutProof from "../components/about/AboutProof";

function AboutPage() {
  const { hash } = useLocation();

  useEffect(() => {
    const id = hash.replace("#", "");
    if (!id) {
      window.scrollTo(0, 0);
      return undefined;
    }

    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 160);

    return () => window.clearTimeout(timer);
  }, [hash]);

  return (
    <>
      <AboutHero />
      <AboutRail />
      <AboutIdentity />
      <AboutPlatform />
      <AboutProof />
    </>
  );
}

export default AboutPage;
